var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",style:({
    'min-height': (_vm.height + "px"),
    'margin-top': (_vm.marginTop + "px"),
    'margin-bottom': (_vm.marginBottom + "px"),
  })},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":_vm.size}}),(!_vm.spinnerOnly)?_c('div',{staticClass:"mt-12",staticStyle:{"font-size":"12px","font-weight":"bold"}},[_vm._v(" LOADING ... ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }